import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';

import { SharedPipesModule } from 'src/pipes/shared-pipes.module';

import { AvatarModule } from '../../components/avatar/avatar.module';
import { MessagingModule } from '../../components/messaging/messaging.module';

import { AdminMessagingRoutingModule } from './admin-messaging-routing.module';
import { AdminMessagingComponent } from './admin-messaging.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    AdminMessagingRoutingModule,
    NgxDatatableModule,
    AvatarModule,
    MessagingModule,
    SharedPipesModule,
  ],
  declarations: [AdminMessagingComponent],
})
export class AdminMessagingModule {}
